export default "__VITE_ASSET__DiyJmJC9__"